module.exports = __webpack_public_path__ + "img/9788992844307.db6e2821.jpg";